import { cookieStorage } from "@/pinia/cookieStorage";

const clearCookie = (name) => {
    document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
};

/**
 * Mirror the auth-expiry behaviour of the axios response interceptor for
 * callers that go around axios (e.g. fetch-based streaming). When the
 * server reports an invalid/expired token, drop the session and bounce
 * the user to /login so they don't get stuck staring at a silent error.
 */
export function redirectOnExpiredAuth() {
    const auth = JSON.parse(cookieStorage.getItem("auth") || "{}");

    if (auth.isImpersonating) {
        auth.isImpersonating = false;
        auth.impersonationExpiresAt = null;
        auth.token = null;
        cookieStorage.setItem("auth", JSON.stringify(auth));
        window.location.pathname = "/login";
        return;
    }

    cookieStorage.removeItem("auth");
    cookieStorage.removeItem("user-uid");
    clearCookie("auth");
    clearCookie("user-uid");

    window.location.pathname = "/login";
}
